














import {Component, Vue, Prop} from 'vue-property-decorator';
import {AlertSettings} from "@/model/AlertSettings";
import AlertPanel from "@/components/alert/AlertPanel.vue";
import { Zone } from '@/model/Zone';

@Component({
  components: {AlertPanel}
})
export default class AlertList extends Vue {

    @Prop({default: {}}) alertSettings: AlertSettings;

    @Prop({default: {}}) zone: Zone;

    selectedSort: string = null;

    sortAlerts(sort: string) {
        this.selectedSort = sort;

        if (sort == "asc") {
            this.alertSettings.emails.sort();
        }
        
        if (sort == "desc") {
            this.alertSettings.emails.reverse();
        }
    }
}
